/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enums_Lesstatus_Actief3Inputs */

const nl_enums_lesstatus_actief3 = /** @type {(inputs: Enums_Lesstatus_Actief3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les actief`)
};

/**

* @param {Enums_Lesstatus_Actief3Inputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const enums_lesstatus_actief3 = /** @type {((inputs?: Enums_Lesstatus_Actief3Inputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enums_Lesstatus_Actief3Inputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_enums_lesstatus_actief3(inputs)
});
export { enums_lesstatus_actief3 as "enums.LesStatus.Actief" }